import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function CTASection({ overline = "Call to Action", title, body, primary, secondary }) {
  return (
    <section className="ccdr-section bg-[#053043] text-white">
      <div className="ccdr-container grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
        <div className="lg:col-span-8">
          <p className="text-xs uppercase tracking-[0.22em] text-[#D4A373] mb-5">
            {overline}
          </p>
          <h2 className="ccdr-h2 text-white mb-4">{title}</h2>
          {body && <p className="text-lg text-[#CBD5E1] leading-relaxed max-w-2xl">{body}</p>}
        </div>
        <div className="lg:col-span-4 flex flex-col gap-3 lg:items-end">
          {primary && (
            <Link to={primary.to} className="ccdr-btn-secondary">
              {primary.label} <ArrowRight className="w-4 h-4" />
            </Link>
          )}
          {secondary && (
            <Link to={secondary.to} className="text-sm text-[#E9C46A] hover:text-white border-b border-[#E9C46A] pb-0.5">
              {secondary.label}
            </Link>
          )}
        </div>
      </div>
    </section>
  );
}
